<template>
  <div class="full-width">
    <div class="container">
      <div class="flex justify-center align-center full-width">
        <div class="notice-info padding full-width">
          <div class="flex justify-center align-center margin-bottom">
            <h1>新闻公告</h1>
          </div>

          <ul :class="UI.isMobile ? 'font-14' : 'font-18 font-weight-400'">
            <li v-for="(item, index) in noticesList" :key="index">
              <div
                @click="toNews(item.id)"
                class="flex align-center justify-between cursor-pointer margin-xs notice-item"
              >
                <div>{{ item.title }}</div>
                <div style="min-width: 150px; text-align: right;">
                  {{ item.c_time.substring(0, 10) }}
                </div>
              </div>
            </li>
          </ul>

          <div class="flex justify-center align-center">
            <el-button type="text" @click="toMore()">查看更多</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticesList } from '@/servers/homepage.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      noticesList: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    let that = this;
    getNoticesList({ page_size: 8 }, function(res) {
      that.noticesList = res.items;
    });
  },

  methods: {
    toNews: function(newsId) {
      this.$router.push({
        name: 'news',
        query: { id: newsId, cate: 'notice' },
      });
      // const url = this.$router.resolve({
      //   name: 'news',
      //   query: { id: newsId, cate: 'notice' },
      // });
      // window.open(url.href, '_blank');
    },

    toMore: function() {
      this.$router.push({
        name: 'newsList',
      });
    },
  },
};
</script>

<style lang="scss">
.notice-item {
  color: #353535;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/home/notices.vue